<template>

  <!-- Tiles Grid Element -->
  <universal-link
    :to="value.link || ''"
    class="tiles-grid-element"
    :target="value.targetBlank && '_blank'">

    <page-block
      no-body
      wrapper-class="row wrap"
      :bg-color="value.bgColor"
      :text-color="value.textColor"
      :text-align="value.textAlign"
      class="tiles-grid-element__wrapper">

      <file-background
        :ratio="5/3"
        v-if="hasFile"
        :value="value.file"
        class="tiles-grid-element__image"/>

      <div
        class="tiles-grid-element__overlay">

        <file-background
          no-placeholder
          :color="value.bgColor"
          class="tiles-grid-element__bg"/>

        <div
          class="tiles-grid-element__text">

          <div
            v-if="value.title.ru"
            v-html="$u.nToBr(value.title.ru)"
            class="tiles-grid-element__title"/>

          <div
            v-if="value.body.ru"
            v-html="value.body.ru"
            class="tiles-grid-element__body"/>

        </div>

      </div>

    </page-block>

  </universal-link>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageElementMixin from '@src/mixins/page-element-mixin';
  import FileBackground from '@src/components/file/file-background';

  export default {
    name: 'tiles-grid-element',
    mixins: [
      PageElementMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      FileBackground,
    },
    computed: {
      imageStyles() {

        const url = this.getFileUrl(
          this.value.file,
          1200,
          '/images/placeholder/image.png',
        );

        return {
          backgroundImage: `url('${url}')`,
        };
      },
    },
  };

</script>

<style lang="scss">

  $cls: tiles-grid-element;

  .tiles-grid-element {
    color: inherit;
    overflow: hidden;
    border-radius: $card-radius;

    &__bg {
      top: 0;
      left: 0;
      width: 100%;
      opacity: .4;
      height: 100%;
      position: absolute;
      background-color: $primary;
    }

    &__text {
      margin-top: .3rem;
      position: relative;
      text-align: center;
    }

    &__text p {
      margin-bottom: 0;
    }

    &__title {
      font-size: 2.1rem;
      font-weight: bold;
      line-height: 2.3rem;
    }

    &__body {
      margin-top: 1rem;
    }

    &__image {
      width: 100%;
      transition: transform .2s linear;
    }

    @media (max-width: $breakpoint-sm) {

      &__title {
        font-size: 1.8rem;
        line-height: 2.1rem;
      }
    }

    @media (max-width: $breakpoint-xs) {

      &__title {
        font-size: 1.4rem;
        line-height: 1.7rem;
      }

      &__body {
        margin-top: .9rem;
      }
    }

    &__wrapper {
      position: relative;
    }

    &__wrapper:hover {

      .#{$cls}__image {
        transform: scale(1.1);
      }
    }

    &__overlay {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      position: absolute;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      padding: $spacer-md $spacer-lg;
      transition: opacity .2s ease-in;
    }
  }

</style>
